import { Box } from '@mui/material';
import Typography from '../typography/typography';
import './chartLegend.scss';
interface IProps {
	legends: string[];
	colors: string[];
}
export function ChartLegends({ legends, colors }: IProps) {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignContent: 'space-between'
			}}>
			{legends.map((legend, index) => (
				<div style={{ marginLeft: '20px', display: 'flex' }}>
					<div
						className='legends-circle'
						style={{ backgroundColor: colors[index] }}></div>
					<Typography type='s5' sx={{ color: '#656669' }}>
						{legend}
					</Typography>
				</div>
			))}
		</Box>
	);
}

export default ChartLegends
